module.exports = __webpack_public_path__ + "static/media/task_checked.3d339d5d.svg";